import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'
import { environment } from '@env'
import {
  GetAllProductFamiliesPagedResponse,
  GetProductFamiliesParams,
  ProductFamily,
  ProductFamilyRequest,
} from '@models'

@Injectable({
  providedIn: 'root',
})
export class ProductFamilyService {
  private readonly baseUrl = `${environment.api.baseUrl}/product-structure/v1/product-families`

  constructor(private http: HttpClient) {}

  async getAll(params: GetProductFamiliesParams): Promise<GetAllProductFamiliesPagedResponse> {
    let httpParams = new HttpParams().set('page', params.page.toString()).set('pageSize', params.pageSize.toString())

    if (params.orderBy) httpParams = httpParams.set('orderBy', params.orderBy)

    if (params.order) httpParams = httpParams.set('order', params.order)

    if (params.text) httpParams = httpParams.set('text', params.text)

    if (params.url) httpParams = httpParams.set('url', params.url)

    if (params.active !== undefined && params.active !== null && params.active !== '')
      httpParams = httpParams.set('active', params.active)

    if (params.startModifiedDate) httpParams = httpParams.set('startModifiedDate', params.startModifiedDate)

    if (params.endModifiedDate) httpParams = httpParams.set('endModifiedDate', params.endModifiedDate)

    const response = await firstValueFrom(
      this.http.get<GetAllProductFamiliesPagedResponse>(this.baseUrl, { params: httpParams })
    )
    return response
  }

  async getById(id: string): Promise<ProductFamily> {
    const response = await firstValueFrom(this.http.get<ProductFamily>(`${this.baseUrl}/${id}`))
    return response
  }

  async create(payload: ProductFamilyRequest): Promise<ProductFamily> {
    const response = await firstValueFrom(this.http.post<ProductFamily>(this.baseUrl, payload))
    return response
  }

  async update(id: string, payload: ProductFamilyRequest): Promise<ProductFamily> {
    const response = await firstValueFrom(this.http.put<ProductFamily>(`${this.baseUrl}/${id}`, payload))
    return response
  }

  async delete(id: string): Promise<void> {
    const response = await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/${id}`))
    return response
  }
}
